module.exports = __webpack_public_path__ + "img/logo-thumb.59872f10.svg";